// tree-cell-template.directive.ts
import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[treeCellTemplate]',
  standalone: true,
})
export class TreeCellTemplateDirective {
  @Input('treeCellTemplate') name!: string; // e.g. "status", "link"

  constructor(public template: TemplateRef<unknown>) {}
}
